// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ProjectGroupDataService } from '../../import-export/service/project-group-data.service';
import { ProjectGroupVO } from '../../../model/vo/project-group.vo';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ProjectGroupLoadingService {

  constructor(private projectGroupDataService: ProjectGroupDataService) {
  }

  public loadOwnedBaseProjectGroups(level: number = 0, importType: string = null): Promise<ProjectGroupVO[]> {
    return lastValueFrom((this.projectGroupDataService.loadOwnedBaseProjectGroups(level, importType)));
  }

  public loadBaseOwnedAndDefaultProjectGroups(level: number = 0): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadBaseOwnedAndDefaultProjectGroups(level));
  }

  public loadProjectGroupById(groupId: number, level: number = 0, sharedToUserId: number = null, importType: string = null, excludeHiddenGroups: boolean = false): Promise<ProjectGroupVO> {
    return lastValueFrom(this.projectGroupDataService.loadProjectGroupById(groupId, level, sharedToUserId, importType, excludeHiddenGroups));
  }

  public searchProjectGroups(searchString: string, importType: string = null, includeOptionValues: boolean = false, projectsLimit: number = 500,
                             includeOnlyOwnedGroups: number = 0) {
    return lastValueFrom(this.projectGroupDataService.searchProjectGroups(searchString, projectsLimit, includeOnlyOwnedGroups, importType, includeOptionValues));
  }

  public loadMyAssignedProjectGroup(userId: number, level: number = 1, importType: string = null): Promise<ProjectGroupVO> {
    return lastValueFrom(this.projectGroupDataService.loadMyAssignedProjectGroup(userId, level, importType));
  }

  public loadPreselectedProjectGroups(preselectedGroupId: number, includeOnlyOwnedGroups: number = 0, importType: string = null): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadPreselectedProjectGroups(preselectedGroupId, includeOnlyOwnedGroups, importType));
  }

  public loadFilteredBaseGroups(sharedUserId: number, baseProjectGroupIds: number[] = []): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadFilteredBaseGroups(sharedUserId, baseProjectGroupIds));
  }

  public loadDefaultImportGroups(): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadDefaultProjectGroups());
  }

  public loadSharedBaseProjectGroups(userId: number, level: number, importType: string): Promise<ProjectGroupVO> {
    return lastValueFrom(this.projectGroupDataService.loadSharedBaseProjectGroups(userId, level, importType));
  }

  public loadOwnedBaseProjectGroupsWithPromise(level: number, importType: string, excludeHiddenGroups: boolean): Promise<ProjectGroupVO> {
    return lastValueFrom(this.projectGroupDataService.loadOwnedBaseProjectGroups(level, importType, excludeHiddenGroups).pipe(
      map((baseGroups: ProjectGroupVO[]) => {
        const baseGroup = new ProjectGroupVO();
        baseGroup.groups = baseGroups;
        baseGroup.projects = [];
        return baseGroup;
      })));
  }

  public loadPinnedProjectGroups(importType: string = null): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadPinnedProjectGroups(importType));
  }

  public loadRecentlyUsedProjectGroups(importType: string = null): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadRecentlyUsedProjectGroups(importType));
  }

  public loadHiddenProjectGroups(importType: string = null): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.projectGroupDataService.loadHiddenProjectGroups(importType));
  }
}
